export const DICTIONARY_CACHE = 'dictionary-api-cache';

export const DAY = 24 * 60 * 60 * 1000;

export const DICTIONARY_CACHE_MAX_AGE = 1 * DAY; // eslint-disable-line no-implicit-coercion
